import { render, staticRenderFns } from "./remocao-list-menu.vue?vue&type=template&id=78b0d818"
import script from "./remocao-list-menu.vue?vue&type=script&lang=js"
export * from "./remocao-list-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports